import Vue from 'vue'
import Router from 'vue-router'
// import Login from '@/components/Login'
import Dashboard from '@/views/Dashboard'
import Tasks from '@/views/tasks/Tasks'
import Task from '@/views/tasks/Task'
import Devices from '@/views/devices/Devices'
import Device from '@/views/devices/Device'
import Customers from '@/views/customers/Customers'
import Customer from '@/views/customers/Customer'
import Orders from '@/views/orders/Orders'
import Order from '@/views/orders/Order'
import Invoices from '@/views/invoices/Invoices'
import Deliveries from '@/views/deliveries/Deliveries'
import Delivery from '@/views/deliveries/Delivery'
import StockReport from '@/views/reports/StockReport'
import OrdersReport from '@/views/reports/OrdersReport'
import Users from '@/views/systemSetup/Users'
import SystemSetup from '@/views/systemSetup/SystemSetup'
import BulkActions from '@/views/systemSetup/BulkActions'

Vue.use(Router)

let routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: Dashboard
  },
  {
    path: '/tasks',
    name: 'Tasks',
    component: Tasks
  },
  {
    path: '/tasks/:id',
    name: 'Task',
    component: Task
  },
  {
    path: '/invoices',
    name: 'Invoices',
    component: Invoices
  },
  {
    path: '/devices',
    name: 'Devices',
    component: Devices
  },
  {
    path: '/devices/:id',
    name: 'Device',
    component: Device
  },
  {
    path: '/customers',
    name: 'Customers',
    component: Customers
  },
  {
    path: '/customers/:id',
    name: 'Customer',
    component: Customer
  },
  {
    path: '/orders',
    name: 'Orders',
    component: Orders
  },
  {
    path: '/orders/:id',
    name: 'Order',
    component: Order
  },
  {
    path: '/deliveries',
    name: 'Deliveries',
    component: Deliveries
  },
  {
    path: '/deliveries/:id',
    name: 'Delivery',
    component: Delivery
  },
  {
    path: '/reports',
    name: 'StockReport',
    component: StockReport
  },
  {
    path: '/reports/orders',
    name: 'OrdersReport',
    component: OrdersReport
  },
  {
    path: '/system-setup',
    name: 'SystemSetup',
    component: SystemSetup
  },
  {
    path: '/system-setup/users',
    name: 'Users',
    component: Users
  },
  {
    path: '/system-setup/bulk-actions',
    name: 'BulkActions',
    component: BulkActions
  }
]

export default new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})